export default __webpack_public_path__ + "static/media/demo1.b80f541f.mp4";